export default __webpack_public_path__ + "static/media/EAST3130.34I-40827_-24131_0.c0fdf989.jpg";